import classes from './FavoriteIcon.module.css';

interface IFavoriteIconProps {
    width?: number | string;
    height?: number | string;
    filled?: boolean;
    fill?: string;
}

const FavoriteIcon: React.FC<IFavoriteIconProps> = ({ width, height = 24, filled = false }) => {
    const iconSrc = filled ? `/icons/new/like_active_black.svg` : `/icons/new/like_disactive_black.svg`;
    return <img src={iconSrc} alt="" aria-hidden="true" className={classes.icon} draggable={false} style={{ height, width: width ?? 'auto' }} />;
};

export default FavoriteIcon;
